import { addToCart } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $forms = Array.from(document.querySelectorAll('.js-product-form') || [])

  if ($forms.length) {
    for (const $form of $forms) {
      $form.addEventListener('submit', (event) => {
        event.preventDefault()

        const formId = $form.id
        const $submitButtons = Array.from(
          new Set([
            ...$form.querySelectorAll('[type="submit"]'),
            ...(formId
              ? document.querySelectorAll(
                  `sticky-atc-bar[data-form-id="${CSS.escape(formId)}"] [type="submit"]`,
                )
              : []),
          ]),
        )
        const $submitButton =
          event.submitter && $submitButtons.includes(event.submitter)
            ? event.submitter
            : $submitButtons[0]

        if (!$submitButton) return

        $submitButtons.forEach((button) => {
          button.setAttribute('disabled', true)
          button.classList.add('loading')
        })

        const formData = new FormData($form)
        const id = formData.get('id')
        const quantity = 1

        // Get line item properties
        const properties = {}
        for (const [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.+)\]$/)
          if (propertyMatch && value) {
            properties[propertyMatch[1]] = value
          }
        }

        addToCart({ id, quantity, properties }).finally(() => {
          $submitButtons.forEach((button) => {
            button.removeAttribute('disabled')
            button.classList.remove('loading')
          })
        })
      })
    }

    document.addEventListener('nova:product:render-form', (event) => {
      const content = event.detail.html
      if (!content) return

      // Sticky ATC portals to body; keep that host alive and only refresh its
      // markup so variant changes don't flash-hide the bar while scrolled.
      // If it is still in the form (portal not run yet), move it first —
      // otherwise the form innerHTML swap destroys it for the session.
      const incomingSticky = content.querySelector('sticky-atc-bar')
      const liveSticky = document.querySelector('sticky-atc-bar')

      if (liveSticky) {
        if (typeof liveSticky.ensurePortaled === 'function') {
          liveSticky.ensurePortaled()
        } else if (liveSticky.parentElement !== document.body) {
          document.body.appendChild(liveSticky)
        }

        incomingSticky?.remove()

        for (const $form of $forms) {
          $form.innerHTML = content.innerHTML
        }

        // Form swap always destroys the observed main action button. Rebind
        // even when incoming sticky markup is absent so the observer cannot
        // stay attached to a detached target and leave the bar stuck visible.
        if (incomingSticky) {
          liveSticky.innerHTML = incomingSticky.innerHTML
        }
        if (typeof liveSticky.rebindIntersectionTarget === 'function') {
          liveSticky.rebindIntersectionTarget()
        }
      } else {
        // No live host — leave sticky in the form markup so it can mount/portal.
        for (const $form of $forms) {
          $form.innerHTML = content.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-upsell', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-product-upsell')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-size-guide', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-size-guide-content')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }

      for (const content of document.querySelectorAll('size-guide-drawer')) {
        if (content) {
          content.reInit()
        }
      }
    })

    document.addEventListener('nova:product:render-inventory-callout', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-inventory-callout')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-collapsible-tabs', (event) => {
      const content = event.detail.html
      if (!content || content.length === 0) return

      for (const [index, newTab] of content.entries()) {
        if (!newTab) continue

        const existingTabs = document.querySelectorAll('.js-update-on-variant-change')
        if (existingTabs[index]) {
          existingTabs[index].innerHTML = newTab.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-product-callout', (event) => {
      const content = event.detail.html
      if (!content) return

      const currentCallout = document.querySelector('.js-product-callout');
      if (currentCallout) {
        currentCallout.innerHTML = content.innerHTML
      }
    })

    document.addEventListener('nova:product:render-title', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-product-title')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }
    })

    document.addEventListener('nova:product:render-description', (event) => {
      const content = event.detail.html
      if (!content) return

      for (const element of document.querySelectorAll('.js-product-description')) {
        if (element) {
          element.innerHTML = content.innerHTML
        }
      }
    })
  }

  if (typeof $sizeGuideDrawer !== 'undefined') {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }

  const container = document.querySelector('.product__info-container');

  // Close all other details when one is shown
  container.addEventListener('sl-show', event => {
    if (event.target.localName === 'sl-details') {
      for (const details of container.querySelectorAll('sl-details')) {
        details.open = event.target === details;
      }
    }
  });
}, { once: true })
